import Image from "next/image";
import { sbBlok } from "@/types/sb-types";

interface TextWithMediaSmallProps {
  blok: sbBlok;
}

const TextWithMediaSmall = ({ blok }: TextWithMediaSmallProps) => {
  return (
    <div className="grid-container py-10">
      <div className="col-start-1 col-span-4 min-[601px]:col-start-1 min-[601px]:col-span-2 lg:col-start-3 lg:col-span-6 2xl:col-start-9 2xl:col-span-8">
        <div className="relative max-w-[400px]">
          <Image
            src={blok.image.filename}
            alt={blok.image.alt}
            width={400}
            height={460}
            className="w-full h-auto object-cover rounded-[10px]"
          />
        </div>
      </div>
      <div className="col-start-1 col-span-4 min-[601px]:col-start-3 min-[601px]:col-span-2 lg:col-start-10 lg:col-span-5 xl:col-start-9 xl:col-span-5 2xl:col-start-18 2xl:col-span-8">
        <div className="flex flex-col h-full justify-center min-[601px]:max-[961px]:pl-5">
          <h2 className="m-0 mt-5 min-[601px]:text-[30px] min-[601px]:m-0">
            Klaus Eldrup-Jørgensen
          </h2>
          <p className="m-0">TrackMan Co-Founder and CEO</p>
        </div>
      </div>
    </div>
  );
};

export default TextWithMediaSmall;
